import { render, staticRenderFns } from "./ShofurInsurance.vue?vue&type=template&id=dc743938&scoped=true"
var script = {}
import style0 from "./ShofurInsurance.vue?vue&type=style&index=0&id=dc743938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc743938",
  null
  
)

export default component.exports